import { $, $$, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y, FreeMode } from 'swiper/modules';

function init() {
  if (!$('[data-au-card-slider]')) return;

  buildSlider();
}

function buildSlider() {
  $$('[data-au-card-slider]').forEach((slider) => {
    new Swiper(slider, {
      modules: [Navigation, Scrollbar, A11y, FreeMode],
      ...sliderConfig,
      breakpoints: {
        768: {
          slidesPerView: 2,
          freeMode: false,
        },
        1360: {
          slidesPerView: slider.getAttribute('data-au-card-slider') === 'snap' ? 3 : 2,
          freeMode: false,
        },
      },
    });
  });
}

export default { init };
